/** Only IDs cross the navigation boundary; authoritative details come from the server. */
export interface CourseSelection {
  universityId: number;
  offeringId: number;
}
export function parseCourseSelection(
  params: URLSearchParams,
): CourseSelection | null {
  const keys = ["universityId", "offeringId"];
  if (!keys.some((key) => params.has(key))) return null;
  if (
    keys.some(
      (key) =>
        params.getAll(key).length !== 1 ||
        !/^[1-9]\d*$/.test(params.get(key) || "") ||
        !Number.isSafeInteger(Number(params.get(key))),
    )
  ) {
    throw new Error(
      "Invalid course selection. Please select the course again.",
    );
  }
  return {
    universityId: Number(params.get("universityId")),
    offeringId: Number(params.get("offeringId")),
  };
}
export function courseApplicationUrl(selection: CourseSelection) {
  return `/applications/new?${new URLSearchParams({ universityId: String(selection.universityId), offeringId: String(selection.offeringId) })}`;
}
